import { render, staticRenderFns } from "./BnplApplicationSuccess.vue?vue&type=template&id=2b776cc4&"
import script from "./BnplApplicationSuccess.vue?vue&type=script&lang=js&"
export * from "./BnplApplicationSuccess.vue?vue&type=script&lang=js&"
import style0 from "./BnplApplicationSuccess.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports